import Calendar from './calendar'

const routes = [
  { path: '/', component: Calendar }
]

export default routes
